import { GenericAuditScreen } from '../GenericAuditScreen'
import TabNavigator from '../TabNavigator'

const AuditTabScreen = () => {
  return (
    <TabNavigator
      title={'F&R Audit'}
      tabs={[
        {
          name: 'riskHoldableAudit',
          component: GenericAuditScreen,
          title: 'Risk Hold Audit',
          initialParams: {
            type: 'PAYOUT_STAGED',
          },
        },
        {
          name: 'riskHoldAudit',
          component: GenericAuditScreen,
          title: 'Risk Release Audit',
          initialParams: {
            type: 'RISK_HOLD',
          },
        },
        {
          name: 'limitHoldAudit',
          component: GenericAuditScreen,
          title: 'Limit Release Audit',
          initialParams: {
            type: 'LIMIT_HOLD',
          },
        },
      ]}
    />
  )
}

export default AuditTabScreen
